/* @flow */
import {isEqual} from 'lodash';

import {trigger as triggerEdap} from '../utils/edapWrapper';
import type {Store} from '../reducers/index';

// We want to ignore some changes in our search query param compare.
const queryParamsMask = {
    neLat: 0,
    neLong: 0,
    swLat: 0,
    swLong: 0,
    zoom: 0,
    include: [],
    ssr: false
};

export const triggerSearchEdap = (store: Store) => {
    // Since the first query is executed server-side this is used to set the parameters that were used once the page gets to the browser.
    const prevSearchParams = {
        ...store.getState().searchParams.prevParams,
        ...queryParamsMask
    };

    const currentSearchParams = {
        ...store.getState().searchParams.params,
        ...queryParamsMask
    };

    // Per TRAVBUGS-62 fire the EDAP search events anytime the query params change except map coordinate changes.
    if (isEqual(prevSearchParams, currentSearchParams)) {
        return;
    }

    const {arrival, departure} = currentSearchParams;

    if (arrival && departure) {
        triggerEdap('dated.search.submit');
    } else {
        triggerEdap('search.submit');
    }
    triggerEdap('search_query.submitted', {
        action_location: 'search'
    });
};
